export function formatSelectOptions(models) {
  return models.map(model => ({
    label: model.name,
    value: model.id,
  }));
}
